// La page d'une seule publication est passée à React
// (js/react/ecrans/Publication.jsx).
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import PagePublication from "../react/ecrans/Publication.jsx";

export const rendre = vueReact(PagePublication);
